<ion-header lines="none">
  <ion-toolbar>

    <ion-title class="color-dark"> </ion-title>

    <ion-buttons slot="start">
      <ion-button (click)="dismiss()" data-cy="colorPickerPrim-toolbar-dismiss">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title color="primary" data-cy="colorPickerPrim-form-title">
       {{colorTitle}}
    </ion-title>

    <ion-buttons slot="end">
      <ion-button class="toolbarButton" color="primary" [disabled]="!colorForm?.valid" (click)="done()"
        data-cy="colorPickerPrim-toolbar-save">
        Save
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content class="padding color-picker-primary">

  <!-- <h3 class="text-center color-dark" data-cy="colorPickerPrim-form-title">
    {{colorTitle}}
  </h3> -->

  <div class="spacer-26"></div>

  <h4 class="color-dark pad-5 padding" data-cy="colorPickerPrim-form-dscr">
    {{colorInstructions}}
  </h4>

  <div class="spacer-26"></div>

  <div class="color-input">
    <div class="color-display" [style.backgroundColor]="'#'+currentColor"
      data-cy="colorPickerPrim-form-currentColor-display">
    </div>
    <div class="enter-color">
      <form [formGroup]="colorForm">
        <ion-item class="rounded">
          <ion-label color="grey">#</ion-label>
          <ion-input mode="ios" lines="none" type="text" [(ngModel)]="currentColor"
            (ngModelChange)="currentColor = $event" placeholder="ex. 1F1F1F" formControlName="inputColor"
            data-cy="colorPickerPrim-form-currentColor-lbl">
          </ion-input>

          <!-- <ion-input mode="ios" *ngIf="!numericInput && rows === 1" #ionInput lines="none" type="text" [(ngModel)]="inputData"
          (keydown)="limitText()" [maxlength]="limitNum" (ngModelChange)="inputData = $event" (keyup)="limitText()"
          (paste)="onPasteHandler($event.clipboardData.getData('text/plain'))" (keyup.enter)="validateBeforeDone()"
          data-cy="editInput-form-input" [debounce]="debounceValue" (ionChange)="limitText()">
        </ion-input> -->


        </ion-item>
      </form>
    </div>
  </div>

  <div class="text-center errorMsgWrapper">
    <span class="errorMsg" *ngIf="!colorForm.controls.inputColor.valid && colorForm.controls.inputColor.dirty"
      data-cy="colorPickerPrim-form-errorMsg">
      {{colorForm.controls.inputColor.errors.colorDomain.colorMessage}}
    </span>
  </div>

  <div class="spacer-17"></div>
  <div class="df-justify-center">
    <ion-radio-group class="text-center" radio-group (ionChange)="handleSelection($event.detail)"
      data-cy="colorPickerPrim-form-colors">
      <ion-radio *ngFor="let color of colors" color="white" [style.backgroundColor]="'#'+color" [value]="color">
      </ion-radio>
    </ion-radio-group>
  </div>
</ion-content>